import type { BetterstartConfigFile } from '@cli-types/core-engine/config.js'

const unsupportedStateMessage =
  'betterstart.config.ts must use the current BetterStart config shape with framework: "next" and frameworkConfig.next. Old top-level srcDir, nextMajorVersion, and paths config is no longer supported.'

export function assertNextConfigShape(config: BetterstartConfigFile): void {
  const candidate = config as BetterstartConfigFile & {
    srcDir?: unknown
    nextMajorVersion?: unknown
    paths?: unknown
  }

  if (
    candidate.srcDir !== undefined ||
    candidate.nextMajorVersion !== undefined ||
    candidate.paths !== undefined ||
    config.framework !== 'next' ||
    !config.frameworkConfig?.next
  ) {
    throw new Error(unsupportedStateMessage)
  }
}
